import { omit } from "lodash";
import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";

import { Filter } from "constants/filters";
import { ReportType } from "constants/reports/report-type";
import { trimObject } from "helpers/object";
import { ApiManager } from "services/api";
import { mapDateRange } from "services/api/helpers";
import { IActionWithPayload } from "store/helper";

import { ReportActions } from "../actions";
import { IFetchReportPayload } from "../interfaces";

export function* fetchAuditLog(action: IActionWithPayload<string, IFetchReportPayload>): SagaIterator {
  const { filters } = action.payload;
  const payload = {
    ...omit(filters, [Filter.DateRange, Filter.Author]),
    // @ts-expect-error TS(2339): Property 'dateRange' does not exist on type 'IRepo... Remove this comment to see the full error message
    ...(filters?.dateRange?.from ? mapDateRange(filters.dateRange.from, filters.dateRange.to) : {}),
    ...{ target: filters?.target || undefined },
    ...{ action: filters?.action || undefined },
    ...(filters?.author && {
      authorID: filters.author,
      authorType: "agent",
    }),
  };

  const response = yield call(ApiManager.auditLogApi.fetchAuditLog, trimObject(payload));

  if (response.result) {
    yield put(
      ReportActions.fetchSuccess({
        data: response.result,
        source: action.payload.source,
        reportType: action.payload.reportType,
      })
    );
  } else {
    yield put(ReportActions.fetchFailure({ error: response.error, reportType: ReportType.AuditLog }));
  }
}
